const locales = {
    zh: () => import('./zh-CN/index'),
    'zh-TW': () => import('./zh-TW/index')
};
const messages = {
    close: 'close'
};
export default { locales, messages };
